export class User {
    FirstName: string;
    LastName: string;
    UserName: string;
    ID: number;

    fullName(): string {
        return this.FirstName + ' ' + this.LastName;
    }
}